import React, { useState } from 'react'
import Grid from "@material-ui/core/Grid"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import { formatDateLocale } from '../../../../../lib/utils.es6'
import EditClaimNote from './EditClaimNote'
import DeleteClaimNote from './DeleteClaimNote'
// import { useStyle } from "./Style";


const ClaimNotes = (props) => {
  const [editingNote, setEditingNote] = useState(null)
  const [deletingNote, setDeletingNote] = useState(null)

  const handleEditNote = (note) => {
    setEditingNote(note)
  }

  const handleDeleteNote = (note) => {
    setDeletingNote(note)
  }

  const handleCloseEdit = () => {
    setEditingNote(null)
  }

  const handleCloseDelete = () => {
    setDeletingNote(null)
  }

//    const classes = useStyle();

  const notes = props.claim.claim_notes || []

  if (notes.length === 0) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" color="textSecondary">
            No notes available for this claim.
          </Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Grid container spacing={2}>
        {notes.map((note, index) => (
          <Grid item xs={12} key={note.guid || index}>
            <Card variant="" >
              <CardContent>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <Typography variant="h6" component="h3" gutterBottom>
                      {note.description}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      {note.text}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="textSecondary">
                          <strong>Created by:</strong> {note.created_by}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="textSecondary">
                          <strong>Created:</strong> {formatDateLocale(note.created_at)}
                        </Typography>
                      </Grid>
                      {note.updated_by && (
                        <>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              <strong>Updated by:</strong> {note.updated_by}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              <strong>Updated:</strong> {formatDateLocale(note.updated_at)}
                            </Typography>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '10px' }}>
                    <IconButton 
                      size="small" 
                      onClick={() => handleEditNote(note)}
                      title="Edit Note"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton 
                      size="small" 
                      onClick={() => handleDeleteNote(note)}
                      title="Delete Note"
                      color="secondary"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {editingNote && (
        <EditClaimNote
          note={editingNote}
          open={!!editingNote}
          onClose={handleCloseEdit}
          onUpdate={props.updateClaimNotes}
          claimGuid={props.claim.guid}
          showUpdateNoteProgressAlert={props.showUpdateNoteProgressAlert}
          showUpdateNotesSuccessAlert={props.showUpdateNotesSuccessAlert}
          showUpdateNotesErrorAlert={props.showUpdateNotesErrorAlert}
          UpdateNotesError={props.UpdateNotesError}
          resetNotesSuccessAlert={props.resetNotesSuccessAlert}
          resetNotesErrorAlert={props.resetNotesErrorAlert}
        />
      )}

      {deletingNote && (
        <DeleteClaimNote
          note={deletingNote}
          open={!!deletingNote}
          onClose={handleCloseDelete}
          onDelete={props.deleteClaimNotes}
          claimGuid={props.claim.guid}
          showDeleteNoteProgressAlert={props.showDeleteNoteProgressAlert}
          showDeleteNotesSuccessAlert={props.showDeleteNotesSuccessAlert}
          showDeleteNotesErrorAlert={props.showDeleteNotesErrorAlert}
          DeleteNotesError={props.DeleteNotesError}
          resetDeleteNotesSuccessAlert={props.resetNotesSuccessAlert}
          resetDeleteNotesErrorAlert={props.resetNotesErrorAlert}
        />
      )}
    </>
  )
}

export default ClaimNotes